'use strict';exports.__esModule = true;

var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _services = require('../../services');
var _currentLocation = require('../../../static/icons/current-location.svg');var _currentLocation2 = _interopRequireDefault(_currentLocation);
var _CurrentLocation = require('./CurrentLocation.scss');var styles = _interopRequireWildcard(_CurrentLocation);
var _MapboxService = require('../../services/MapboxService/MapboxService');var _MapboxService2 = _interopRequireDefault(_MapboxService);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} /* global google */var

CurrentLocation = function (_Component) {_inherits(CurrentLocation, _Component);function CurrentLocation() {var _temp, _this, _ret;_classCallCheck(this, CurrentLocation);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    handleClick = function () {
      _services.GeolocationService.geolocate({ enableHighAccuracy: true }).
      then(_this.showCurrentLocation).
      catch(function (error) {return console.error(error);});
    }, _this.

    showCurrentLocation = function (coords) {
      if (_this.marker) {
        _this.marker.remove();
        _this.marker = null;
      }

      var el = document.createElement('img');
      el.src = _currentLocation2.default;
      _this.props.map.setZoom(16);
      _this.props.map.setCenter(coords);
      _this.marker = new _MapboxService2.default.Marker({
        element: el });


      _this.marker.setLngLat([coords.lng, coords.lat]);
      _this.marker.addTo(_this.props.map);
    }, _temp), _possibleConstructorReturn(_this, _ret);}CurrentLocation.prototype.

  render = function render() {var _cx;var _props =
    this.props,className = _props.className,isMobile = _props.isMobile;

    return (
      _react2.default.createElement('button', {
          className: (0, _classnames2.default)(styles.locationButton, className, (_cx = {}, _cx[styles.isMobile] = isMobile, _cx)),
          onClick: this.handleClick },

        _react2.default.createElement('i', { className: 'icon icon-location' })));


  };return CurrentLocation;}(_react.Component);exports.default = CurrentLocation;


CurrentLocation.propTypes = {
  map: _propTypes2.default.object,
  isMobile: _propTypes2.default.bool,
  className: _propTypes2.default.string };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CurrentLocation/CurrentLocation.js
// module id = 2615
// module chunks = 0